import { defineNuxtPlugin, useHead, useRuntimeConfig } from 'nuxt/app'

const EU_REGIONS =
  'AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE,GB,NO,IS,LI,GG,SM,VA,AD'

const consentDefaultsScript = `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag("consent", "default", {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
  functionality_storage: "denied",
  personalization_storage: "denied",
  security_storage: "granted",
  wait_for_update: 2000,
  region: [${EU_REGIONS.split(',')
    .map((r) => `"${r}"`)
    .join(',')}]
});
gtag("set", "ads_data_redaction", true);
gtag("set", "url_passthrough", true);
`

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  if (!config.public.cookieyesId) {
    return
  }

  if (process.server) {
    nuxtApp.vueApp.runWithContext(() => {
      useHead({
        script: [
          {
            id: 'consent-defaults',
            innerHTML: consentDefaultsScript,
            tagPriority: -3,
          },
          {
            src: `https://cdn-cookieyes.com/client_data/${config.public.cookieyesId}/script.js`,
            type: 'text/javascript',
            async: true,
            id: 'cookieyes',
            tagPriority: 1,
          },
        ],
      })
    })
  }
})
